import React from "react"

function FooterC() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={67}
        y={57}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={67}
        y={65}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={67}
        y={72}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={67}
        y={79}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={67}
        y={86}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={57}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={65}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={72}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={79}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={20}
        y={86}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={115}
        y={57}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={115}
        y={65}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={115}
        y={72}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={115}
        y={79}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={115}
        y={86}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={163}
        y={57}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={163}
        y={65}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={163}
        y={79}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={163}
        y={72}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={163}
        y={86}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={57}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={211}
        y={65}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={72}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={79}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={86}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={199}
        y={117}
        width={48}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <path stroke="var(--base-300)" d="M266 103.5H0" />
      <path
        d="M79 114a2 2 0 012-2h25a2 2 0 012 2v6a2 2 0 01-2 2H81a2 2 0 01-2-2v-6z"
        fill="var(--main-500)"
      />
      <rect
        x={20}
        y={112}
        width={55}
        height={10}
        rx={2}
        fill="var(--base-400)"
      />
      <path fill="var(--base-200)" d="M0 131h266v19H0z" />
      <rect
        x={20}
        y={139}
        width={41}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={222}
        y={139}
        width={25}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
    </svg>
  )
}

export default FooterC
